module.exports = __webpack_public_path__ + "img/Anette.5b5d9f23.png";